exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.workflow-accordion-conautomation_template_editortainer-modify-record {\n  padding: 0px 10px 10px 10px;\n  max-height: 400px;\n  overflow-y: scroll;\n}\n.popup-container-main {\n  z-index: 999 !important;\n}\n.addCheck {\n    background-color: aliceblue;\n}\n", ""]);

// exports
